export default __webpack_public_path__ + "static/media/AcceleronsGallery_34.5f205f02.JPG";